module.exports = __webpack_public_path__ + "static/media/blobs-mb-en.2272d849.png";